import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

interface TestimonialProps {
  text: string;
  author: string;
}

export default function Testimonial({ text, author }: TestimonialProps) {
  return (
    <Stack spacing={0} alignItems='center' justifyContent='center' sx={{ width: '100%', flex: 1 }}>
      <Box sx={{ display: 'flex', gap: 0.5, mb: 2 }}>
        {[...Array(5)].map((_, index) => (
          <StarIcon
            key={index}
            sx={{
              color: '#FFD700',
              fontSize: '1.5rem',
            }}
          />
        ))}
      </Box>
      <Typography
        align='center'
        sx={{
          maxWidth: '600px',
          fontSize: { xs: '0.8rem', sm: '1rem' },
          lineHeight: 1.6,
          color: 'text.primary',
          fontWeight: 400,
          px: { xs: 2, sm: 4 },
        }}
      >
        {text}
      </Typography>
      <Typography
        sx={{
          color: 'text.secondary',
          fontWeight: 500,
          fontSize: { xs: '0.8rem', sm: '1rem' },
        }}
      >
        - {author}
      </Typography>
    </Stack>
  );
}
